export class ISettings {
    dueDate: Date;
    gymStartingDate: Date;
}